import { User } from '@paragon/contract-library';

export type NamedUser = Pick<User, 'email' | 'firstName' | 'lastName'>;

/** The user's full name, or their email address if they have no name. */
export function getUserDisplayName(user: NamedUser) {
  return `${user.firstName} ${user.lastName}`.trim() || user.email;
}

/** The user's initials, e.g. `JD`, or the first letter of their email address if they have no name. */
export function getUserInitials(user: NamedUser) {
  return (`${user.firstName.charAt(0)}${user.lastName.charAt(0)}` || user.email.charAt(0)).toUpperCase();
}

/**
 * Stands in for a user who isn't in the organization roster (they have left, or the roster failed to load), so they are
 * shown by address rather than not at all.
 */
export function getUnknownUser(email: string): NamedUser {
  return { email, firstName: '', lastName: '' };
}
